import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';

export type ToggleButtonGroupProps = MuiToggleButtonGroupProps;
export const ToggleButtonGroup = MuiToggleButtonGroup;
